module.exports = __webpack_public_path__ + "static/media/STEM.fda4d470.jpg";